<app-test-workflow-modal
  *ngIf="showTestModal"
  [isOpen]="showTestModal"
  [workflowId]="testWorkflowId"
  [versionId]="testVersionId"
  [clientId]="_context?.client?.id"
  (closed)="showTestModal = false">
</app-test-workflow-modal>

<div class="local-overlay-container">
  <button
  mat-raised-button
  color="primary"
  class="split-button"
  type="button"
>
  <div style="display: flex; flex-direction: row; align-items: center;">

    <span
      class="split-button-text"
      (click)="onTestClick(row.id, row.workflowVersionId)"
    >
      Test
    </span>

    <!-- ✅ FIX: use button instead of span -->
    <button
      mat-icon-button
      [matMenuTriggerFor]="menu"
      (click)="$event.stopPropagation()"
      class="split-button-icon"
    >
      <mat-icon>expand_more</mat-icon>
    </button>

  </div>
</button>

<mat-menu #menu="matMenu" xPosition="before" panelClass="menu-container">
  <!-- ✅ View Workflow → new tab -->
    <button
      mat-menu-item
      [routerLink]="['/admin/workflow-builder/readonly', row.id, row.workflowVersionId]"
      target="_blank"
      *ngIf="isEntitledToViewWorkflow"
    >
      View Workflow
    </button>

    <!-- ✅ Import Workflow → keep modal -->
    <button
      mat-menu-item
      (click)="onImportWorkflow()"
      *ngIf="isEntitledToImportWorkflow"
    >
      Import Workflow
    </button>
</mat-menu>
</div>
